import { c as _c } from "react/compiler-runtime";
import { graphql, useQuery } from "@opensea/graphql";
import { ActionTimelineFragment } from "../../../../components/ActionTimeline/ActionTimeline.fragment";
import { NETWORK_ONLY_OPERATION_CONTEXT } from "../../../../constants";
import { useSetBlockchainActionErrors } from "../../../hooks/useSetBlockchainActionErrors";
import { useSetBlockchainActionErrorsFragment } from "../../../hooks/useSetBlockchainActionErrors.fragment";
const PublishDropQuery = graphql(`
    query PublishDropQuery($collectionSlug: String!) {
      publishDrop(collectionSlug: $collectionSlug) {
        actions {
          ...ActionTimeline
        }
        errors {
          ...useSetBlockchainActionErrors
        }
      }
    }
  `, [ActionTimelineFragment, useSetBlockchainActionErrorsFragment]);
export const useDropPublishQuery = params => {
  const $ = _c(14);
  const {
    collectionSlug,
    pause
  } = params;
  let t0;
  if ($[0] !== collectionSlug) {
    t0 = {
      collectionSlug
    };
    $[0] = collectionSlug;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== pause || $[3] !== t0) {
    t1 = {
      query: PublishDropQuery,
      variables: t0,
      pause,
      context: NETWORK_ONLY_OPERATION_CONTEXT
    };
    $[2] = pause;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const [t2, refetch] = useQuery(t1);
  const {
    data,
    error,
    fetching
  } = t2;
  let t3;
  if ($[5] !== data?.publishDrop?.actions) {
    t3 = data?.publishDrop?.actions ?? [];
    $[5] = data?.publishDrop?.actions;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const actions = t3;
  useSetBlockchainActionErrors(data?.publishDrop?.errors);
  let t4;
  if ($[7] !== refetch) {
    t4 = () => refetch({
      requestPolicy: "network-only"
    });
    $[7] = refetch;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== actions || $[10] !== error || $[11] !== fetching || $[12] !== t4) {
    t5 = {
      actions,
      error,
      fetching,
      refetch: t4
    };
    $[9] = actions;
    $[10] = error;
    $[11] = fetching;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};